import React from 'react';
import { useTranslation } from 'react-i18next';

import Seo from 'sharedComponents/Seo';

import Footer from 'sharedComponents/Footer';
import Header from './components/Header';
import Banner from './components/Banner';
import Description from './components/Description';

const NonAuthHomePage = ({ locals }) => {
  const { t } = useTranslation();
  const { banner, description } = locals;

  return (
    <div>
      <Seo title={t('meta.NonAuthHomePage.title')} />
      <Header />
      <Banner data={banner} />
      <Description data={description} />
      <Footer />
    </div>
  );
};

export default NonAuthHomePage;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/NonAuthHomePage.js